import useFetchAllCategories from './useFetchAllCategories';

export default function useGetCategoriesLinks() {
  const { allCategories } = useFetchAllCategories();

  const categoriesLinks = Object.values(allCategories)
    .map((category) => {
      const { categoryDbName, categoryName, slugi18n, tier } = category;

      return {
        id: categoryDbName,
        url: `/${slugi18n}/`,
        name: categoryName,
        tier,
      };
    })
    .filter((cat) => cat)
    .sort((a, b) => b.tier - a.tier);

  return {
    categoriesLinks,
  };
}
